import React from "react";
import { UploadedFile } from "../types/UploadedFile.type";
import { FileItem } from "./FileItem";
import { SharedFileItemProps } from "../types/ShareProps.types";

export type FileListProps =
	| ({ isPreview: true } & SharedFileItemProps & { files: UploadedFile[] })
	| ({ isPreview?: false } & SharedFileItemProps & { files: UploadedFile[] });

export const FileList: React.FC<FileListProps> = ({
	files,
	isPreview,
	extraData,
	onRemove,
	onUploadComplete,
	onUploadStart,
	onUploadError,
}) => {
	if (!files || files.length === 0) {
		return null;
	}

	return (
		<div className={`mt-3 grid grid-cols-1 gap-3 md:grid-cols-${files.length === 1 ? "1" : "2"}`}>
			{files.map((file) => (
				<FileItem
					key={file.id ?? file.uploadId}
					file={file}
					extraData={extraData}
					isPreview={isPreview}
					onRemove={onRemove}
					onUploadComplete={onUploadComplete}
					onUploadStart={onUploadStart}
					onUploadError={onUploadError}
				/>
			))}
		</div>
	);
};
